import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React, { Suspense } from "react";
import Loading from "./common/Loading";
import { routesConfig } from "./routesConfig";
import { usePageTracking } from "./hooks/usePageTracking";

function renderRoutes(routes) {
  return routes.map(({ path, component: Component, children, index }, i) => (
    <Route key={i} path={path} element={<Component />}>
      {children &&
        children.map((child, j) => (
          <Route
            key={j}
            index={child.index}
            path={child.path}
            element={<child.component />}
          />
        ))}
    </Route>
  ));
}

function App() {
  return (
    <Router>
      <TrackedRoutes />
    </Router>
  );
}

function TrackedRoutes() {
  usePageTracking();

  return (
    <Suspense fallback={<Loading />}>
      <Routes>{renderRoutes(routesConfig)}</Routes>
    </Suspense>
  );
}

export default App;
